import script from "./AccountFeaturesConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountFeaturesConfig.vue?vue&type=script&lang=ts&setup=true"

import "./AccountFeaturesConfig.vue?vue&type=style&index=0&id=7006e544&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7006e544"]])

export default __exports__